<template>
    <div class="details_monito_score mt-16">

    	<div class="title mb-12">
   			<h2 class="fs-28 fs-md-25 fs-sm-24 lh-6 ls-2 ls-sm-2 lh-sm-5 mt-5 mb-1 mb-sm-3">What does a {{provider.score}} Monito score for {{provider.name}} mean?</h2>
    		<a href="https://www.monito.com/en/lp/money-transfer-services-review-temporary" class="fs-17 ls-1 underline fs-md-17 fs-sm-17 italic fw-demi-bold f-anti" style="opacity: 0.88;">Learn more about our scoring methodology</a>
  		</div>  
  		<div class="flex"> 
    	<div class="box shadow">
    		<h3 class="f-anti pt-8 pl-2 pb-6">Trust & Credibility<span :class="['big_score f-anti',getColorScore(provider.sub_score_01)]">{{provider.sub_score_01}}</span></h3>
    		
    		<ul>
    			<li v-for="detail in details_trust" class="f-anti">
    				<p class="label">{{detail.label}}</p>
    				<div class="barre">
    					<div :class="['element_barre',getColorScore(detail.score)]" :style="'width: '+ detail.score * 10+'%'"></div>
    					<span class="sub_score">{{detail.score}}</span>
    				</div>
    				<p class="infos">{{detail.infos}}</p>
    			</li>
    		</ul>
            <div v-if="!scrollingActive && !paragraph_01" v-html="small_trust"></div>
            <div v-if="!scrollingActive && paragraph_01" v-html="trust" class="pb-8"></div>
            <a v-if="!scrollingActive && !paragraph_01" @click="paragraph_01=!paragraph_01">Read more</a>
            <a v-if="scrollingActive" @click="anchor01">Read more</a>
    	</div>
    	<div class="box shadow">
    		<h3 class="f-anti pt-8 pl-2 pb-6">Service Quality<span :class="['big_score f-anti',getColorScore(provider.sub_score_02)]">{{provider.sub_score_02}}</span></h3>

    		
    		<ul>
    			<li v-for="detail in details_service" class="f-anti">
    				<p class="label">{{detail.label}}</p>
    				<div class="barre">
    					<div :class="['element_barre',getColorScore(detail.score)]" :style="'width: '+ detail.score * 10+'%'"></div>
    					<span class="sub_score">{{detail.score}}</span>
    				</div>
    				<p class="infos">{{detail.infos}}</p>
    			</li>
    		</ul>
            <div v-if="!scrollingActive && !paragraph_02" v-html="small_service"></div>
            <div v-if="!scrollingActive && paragraph_02" v-html="service" class="pb-8"></div>
            <a v-if="!scrollingActive && !paragraph_02" @click="paragraph_02=!paragraph_02">Read more</a>
            <a v-if="scrollingActive" @click="anchor02">Read more</a>
    	</div><div class="box shadow">
    		<h3 class="f-anti pt-8 pl-2 pb-6">Customer satisfaction<span :class="['big_score f-anti',getColorScore(provider.sub_score_03)]">{{provider.sub_score_03}}</span></h3>
    		<ul>
    			<li v-for="detail in details_customer" class="f-anti">
    				<p class="label">{{detail.label}}</p>
    				<div class="barre">
    					<div :class="['element_barre',getColorScore(detail.score)]" :style="'width: '+ detail.score * 10+'%'"></div>
    					<span class="sub_score">{{detail.score}}</span>
    				</div>  
    				<p class="infos">{{detail.infos}}</p>
    			</li>
    		</ul>
            <div v-if="!scrollingActive && !paragraph_03" v-html="small_customer"></div>
            <div v-if="!scrollingActive && paragraph_03" v-html="customer" class="pb-6"></div>
            <a v-if="!scrollingActive && !paragraph_03" @click="paragraph_03=!paragraph_03">Read more</a>
            <a v-if="scrollingActive" @click="anchor03">Read more</a>
    	</div><div class="box shadow">
    		<h3 class="f-anti pt-8 pl-2 pb-6">Fees & Exchange rates<span :class="['big_score f-anti',getColorScore(provider.sub_score_04)]">{{provider.sub_score_04}}</span></h3>
    		
    		<ul>	
    			<li v-for="detail in details_fees" class="f-anti">
    				<p class="label">{{detail.label}}</p>
    				<div class="barre">
    					<div :class="['element_barre',getColorScore(detail.score)]" :style="'width: '+ detail.score * 10+'%'"></div>
    					<span class="sub_score">{{detail.score}}</span>
    				</div>
    				<p class="infos">{{detail.infos}}</p>
    			</li>
    		</ul>
            <div v-if="!scrollingActive && !paragraph_04" v-html="small_fees"></div>
            <div v-if="!scrollingActive && paragraph_04" v-html="fees" class="pb-6"></div>
            <a v-if="!scrollingActive && !paragraph_04" @click="paragraph_04=!paragraph_04">Read more</a>
            <a v-if="scrollingActive" @click="anchor04">Read more</a>
    	</div>
    </div>	
    	 
    </div>
</template>

<script>
	export default {
		props:['scrollingActive','provider','details_trust','details_service','details_customer','details_fees', 'fees', 'trust', 'customer', 'service','small_fees', 'small_trust', 'small_customer', 'small_service'],
        data() {
            return {
                paragraph_01 : false,
                paragraph_02 : false,
                paragraph_03 : false,
                paragraph_04 : false
            }
        },
		methods : {
            getColorScore(score){
                if(score >= '9.5'){
                  return 'excellent';
                } else if(score >= '8'){
                  return 'good';
                } else if(score >= '6.5'){
                  return 'average';
                } else if(score >= '5.0'){
                  return 'poor';
                } else if(score == '10'){
                  return 'excellent';
                } else {
                  return 'bad';
                }
            },
            anchor01(){
              $([document.documentElement, document.body]).animate({
                scrollTop: $("#anchor01").offset().top - 60
              }, 1000);
            },
            anchor02(){
              $([document.documentElement, document.body]).animate({
                scrollTop: $("#anchor02").offset().top - 60
              }, 1000);
             
            },
            anchor03(){
              $([document.documentElement, document.body]).animate({
                scrollTop: $("#anchor03").offset().top - 60
              }, 1000);
            },
            anchor04(){
              $([document.documentElement, document.body]).animate({
                scrollTop: $("#anchor04").offset().top - 60
              }, 1000);
            }
      	}
	}
</script>

<style lang="scss" scoped> 

.details_monito_score {
	
}

.flex {
	display: flex;
	width: 90%;
	padding-left: 5%;
	padding-right: 5%;
	padding-bottom: 60px;
	justify-content: center;
	align-items: flex-start;
	position: relative;		
}

.title {
	width: 620px;
	text-align: center;
	margin-left: auto;
	margin-right: auto;

}

.box {
	width: 345px;
	background: #fff;
	margin: 0 1.2%;
	border-radius: 12px;

    & > a {
        text-align: center;
        color: #F6495C;
        text-decoration: underline;
        margin-left: auto;
        margin-right: auto;
        display: block;
        padding-top: 25px;
        margin-top: 0;
        margin-bottom: 0;
        padding-bottom: 40px;
        cursor: pointer;
    }
}



ul {
	padding-left: 0;
	list-style: none;
}

li {
	padding-left: 26px;
	padding-right: 18px;
	padding-top: 22px; 
	padding-bottom : 22px;

	.label {
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 3px;
		max-width: 84%;
		letter-spacing: 0.025em;
	}

	.infos {
		max-width: 84%;
		font-size: 15px;
		font-weight: 500;
		opacity: 0.85;
		line-height: 20px;
		letter-spacing: 0.02em;
	}

	&:last-child {
		border-bottom: none;
		padding-bottom: 10px;
	}

	&:hover {
		background: #cdcdcd22;
	}
}

h3 {
	font-size : 20px;
	position: relative;
	padding-right: 30%;
	box-sizing: border-box;
	position: sticky;
	top: 0;
	border-radius: 12px;
	background: #fff;
	z-index: 100000;

    a {
        position: absolute;
        top: 72px;
        padding-right: 30%;
        left: 24px;
        opacity: 0.85;
        font-size: 14px;
        text-decoration: underline;

        &:hover {
            color: #F6495C;
            cursor: pointer;
        }
    }

	.big_score {
		position: absolute;
		right: 14px;
		color: #fff;
		top: 45px;
		font-size: 17px;
		padding-right: 14px;
		padding-left: 14px;
		padding-top: 7px;
		padding-bottom: 6px;
		border-radius: 40px;
		background: #ff000060;

        &.excellent {
            background-color: #78ca00;
        }

        &.good {
            background-color: #00a000;
        }

        &.average {
            background-color: #ff9a00;
        }

        &.poor {
            background-color: #ff5800;
        }

        &.bad {
            background-color: #ff0030;
        }
	}
}



.sub_score {
        width: 10%;
        position: absolute;
        display: inline-block; 
        text-align:center;
        top: -7px;
        right: -52px;
        margin-bottom: 12px;
        font-weight: 700;
    }

    .barre {
        width: calc( 100% - 65px);
        height: 9px;
        margin-top: 8px;
        border-radius: 5px;
        position: relative;
        background: #D2D1D270;
        display: inline-block;
        margin-bottom: 12px;

        .element_barre {
            height: 9px;
            border-radius: 5px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .excellent {
            background-color: #78ca00;
        }

        .good {
            background-color: #00a000;
        }

        .average {
            background-color: #ff9a00;
        }

        .poor {
            background-color: #ff5800;
        }

        .bad {
            background-color: #ff0030;
        }
    }

     @media ($tablet_paysage_only) {
        .box {
            width: 44%;
            margin: 0 3%;
            margin-bottom:30px;
            flex-shrink: 0;
            & > div {
                padding-left: 8%;
                padding-right: 8%;
                width: 84%;
            }
        }
        .flex{
           flex-wrap: wrap!important;
        }
    }


     @media ($tablet_portrait) {
        .flex {
            padding: 0;
           display: flex;
            width: 100%;
            justify-content: space-around;
            flex-flow: column wrap;
        }

        .box {
            box-sizing: border-box;
            width: 92%;
            height: auto;
            margin: 4%;
            & > div {
                padding-left: 8%;
                padding-right: 8%;
                width: 84%;
            }
        }

        .title {
            width: 92%;
            height: auto;
            margin: 4%; 
        }


     }
</style> 








// WEBPACK FOOTER //
// src/components/WidgetDetailsMonitoScore.vue